export default __webpack_public_path__ + "static/media/Magadhi_agri1_f.1c647d4a.wav";